<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<div [ngClass]="{'error': isError}" class="bar">
    <div (mouseout)="tooltipToggle.emit(false)"
         (mouseover)="tooltipToggle.emit(true)"
         class="dot">
        <app-tooltip-persistent [closeTooltipEvent]="closeTooltipEvent"
                                [disable]="disableTooltip()"
                                [extraCssClasses]="['claim-persistent-tooltip']"
                                [placement]="tooltipPlacement"
                                [tooltipBody]="tooltipBody"
                                [tooltipToggle]="tooltipToggle">
        </app-tooltip-persistent>
    </div>
</div>

<ng-template #tooltipBody>
    <div class="tooltip-header modal-header info">
        <p class="tooltip-title modal-title" data-cy="claim-status-tooltip-title">
            {{tooltipTitle}}
        </p>
        <button (click)="closeTooltipEvent.emit()" class="tooltip-close close"
                data-cy="claim-status-tooltip-title-close-button"
                type="button"></button>
    </div>

    <div class="tooltip-body modal-body" data-cy="claim-status-tooltip-body">
        <ng-container *ngTemplateOutlet="tooltipMessage"></ng-container>
    </div>
</ng-template>
